import { FlowPage } from 'src/lib/flow/FlowPage';
import { AnswerSet } from 'src/store/sellerFlow/AnswerSet';

import { FlowQuestion } from './FlowQuestion';

export const isAgent = (answers: AnswerSet, channel: string): boolean => {
  return (
    channel === 'agent_request' ||
    answers['seller.relation_to_owner'] === 'Agent' ||
    answers['seller.relation_to_owner'] === 'AgentAndOwner' ||
    answers['seller.agent_status'] === 'is_agent' ||
    answers['seller.agent_status'] === 'owner_and_agent'
  );
};

export const isWorkingWithHomebuilder = (
  answers: AnswerSet,
  homebuilderIdentifier?: string,
): boolean => {
  return answers['seller.working_with_home_builder'] === true || !!homebuilderIdentifier;
};

export const isNonSeriousSeller = (answers: AnswerSet): boolean => {
  return answers['seller.sale_timeline'] === 'Just Browsing';
};

export const isEligibleForLongboardingExperiment: FlowPage['isEnabled'] = ({
  answers,
  inputContext: { channel },
}) => !isAgent(answers, channel) && !isNonSeriousSeller(answers);

export const replaceQuestionType = (
  key: string,
  newType: string,
  questions: Array<FlowQuestion>,
) => {
  return questions.map((q) => {
    if (q.key == key) {
      return { ...q, type: newType };
    }
    return q;
  });
};
